import { ReactElement } from 'react';
import { Box, Icon } from '@ff-it/ui';
import { TitleContainer } from 'components/TitleContainer';
import type { ContentObject } from 'modules/core/context';

export function ContentObjectWidget({
  content_object: { icon, title, subtitle },
}: {
  content_object: ContentObject;
}): ReactElement {
  const titleElement = icon ? (
    <Box display="flex">
      <Icon icon={icon} mr="1" /> {title}
    </Box>
  ) : (
    title
  );

  return <TitleContainer title={titleElement} subtitle={subtitle} />;
}
